export default __webpack_public_path__ + "static/media/fox.860e1379.png";